export const formatSubtopics = (text: string) => {
  return text.replaceAll(', ', '∙')
}
